import {
  SET_SEARCHING,
  SET_EXPORTING,
  SET_PROJECT_LIST,
  SET_PROJECT_QUERY,
  SET_PROJECT_PAGETOTAL,
  SET_PROJECT_PAGE_NUM,
  SET_PROJECT_PAGE_SIZE,
} from './mutation-types'
import api from '@/api'
import files from 'file-saver'
import {objectTrim, getHeaderName} from '@/utils'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  userId: '',
  userName: '',
})

const state = {
  searching: false,
  exporting: false,
  initQuery: initQuery(),
  projectDetail: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_EXPORTING] (state, payload) {
    state.exporting = payload
  },
  [SET_PROJECT_LIST] (state, payload) {
    state.projectDetail.list = payload
  },
  [SET_PROJECT_QUERY] (state, payload) {
    state.projectDetail.query = {
      ...state.projectDetail.query,
      ...payload,
    }
  },
  [SET_PROJECT_PAGETOTAL] (state, payload) {
    state.projectDetail.listPageTotal = payload
  },
  [SET_PROJECT_PAGE_NUM] (state, payload) {
    state.projectDetail.query.pageNum = payload
  },
  [SET_PROJECT_PAGE_SIZE] (state, payload) {
    state.projectDetail.query.pageSize = payload
  },
}

const actions = {
  // 初始化包项目明细
  initList ({dispatch}) {
    dispatch('setPageNum', 1)
  },
  // 获取包项目明细
  async getList ({commit, state, dispatch}, payload) {
    try {
      let params = {
        ...objectTrim(state.projectDetail.query),
        ...payload,
      }
      if (payload && !payload.userName && params.userName) {
        delete params.userName
      }
      commit(SET_SEARCHING, true)
      const {data, code} = await api.packApi.queryPackProject(params)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('getList', {
            ...other,
            userId,
          })
        },
      })
      if (data) {
        commit(SET_PROJECT_PAGE_NUM, data.pageNum || 1)
        commit(SET_PROJECT_PAGETOTAL, data.total || 0)
        commit(SET_PROJECT_LIST, data.items || [])
        commit(SET_PROJECT_PAGE_SIZE, data.pageSize || 50)
      }
    } catch (error) {
      commit(SET_PROJECT_PAGETOTAL, 0)
      commit(SET_PROJECT_LIST, [])
    }
    commit(SET_SEARCHING, false)
  },
  // 导出包项目明细
  async exportExcel ({commit, dispatch}, payload) {
    let params = {
      ...objectTrim(state.projectDetail.query),
      ...payload,
    }
    if (payload && payload.userId && params.userName) {
      delete params.userName
    }
    commit(SET_EXPORTING, true)
    const res = await api.packApi.exportPackProject(params)
    const {data, headers} = res
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = params
            dispatch('exportExcel', {
              ...other,
              userId,
            })
          },
        })
      }
      reader.readAsText(res.data)
    }
    commit(SET_EXPORTING, false)
  },
  async editPackProject ({commit}, payload) {
    const {result, code} = await api.packApi.saveOrUpdatePackProject(payload)
    return {result, code}
  },
  async deletePackProject ({commit}, payload) {
    const {result, code} = await api.packApi.deletePackProject(payload)
    return {result, code}
  },
  setQuery ({commit, state}, payload) {
    commit(SET_PROJECT_QUERY, payload)
  },
  setPageSize ({commit, dispatch}, payload) {
    commit(SET_PROJECT_PAGE_SIZE, payload)
    commit(SET_PROJECT_PAGE_NUM, 1)
    // dispatch('getList')
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_PROJECT_PAGE_NUM, payload)
    // dispatch('getList')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
